import { render, staticRenderFns } from "./VisitorAttendance.vue?vue&type=template&id=3c21246c&scoped=true&"
import script from "./VisitorAttendance.vue?vue&type=script&lang=js&"
export * from "./VisitorAttendance.vue?vue&type=script&lang=js&"
import style0 from "./VisitorAttendance.vue?vue&type=style&index=0&id=3c21246c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c21246c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VDataTable})
